import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = ({ mode = 'daily', onChangeMode, onOpenLanding }) => {
  return (
    <header className="app-header">
      <h1 className="app-header__title"><Link to="/" className="app-header__home-link">LoL Champion Guessr</Link></h1>
      <div className="app-header__actions">
        <div className="mode-switch">
          <button
            className={`mode-btn ${mode === 'daily' ? 'active' : ''}`}
            onClick={() => mode !== 'daily' && onChangeMode && onChangeMode('daily')}
            aria-pressed={mode === 'daily'}
          >
            Daily
          </button>
          <button
            className={`mode-btn ${mode === 'infinite' ? 'active' : ''}`}
            onClick={() => mode !== 'infinite' && onChangeMode && onChangeMode('infinite')}
            aria-pressed={mode === 'infinite'}
          >
            Infinite
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;


